import React from "react";

const OrgsContext = React.createContext({});

export default OrgsContext;
